import React from 'react';
import CategoryPage from '../components/CategoryPage';

const BusinessAddressesPage = () => {
  return <CategoryPage categoryId="business-addresses" />;
};

export default BusinessAddressesPage;